export default __webpack_public_path__ + "static/media/4.34b30ad3.jpg";